import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import { LoadUser } from './user.model';
import { UserState } from './user.state';

@Injectable()
export class MunicipalityCodeSetupGuard implements CanActivate {
  private queryParamsSub: any;

  errorMessage;

  constructor(private store: Store) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return Observable.create(observer => {
      const user = this.store.selectSnapshot(UserState.user);
      if (user && !user.loading) this.checkUser(user, observer);
      else
        this.store
          .dispatch(new LoadUser())
          .subscribe(() =>
            this.checkUser(this.store.selectSnapshot(UserState.user), observer)
          );
    });
  }

  checkUser(user, observer) {
    if (user.hasChosenMunicipalityCode) {
      observer.next(true);
      observer.complete();
    } else {
      observer.next(false);
      observer.complete();
      this.store.dispatch(new Navigate(['/settings/municipality-selector']));
    }
  }
}
